import { FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';

export type SourceOfFundsAutomatedActionType = 'compliance-restriction' | 'send-email' | 'show-popup' | 'none';

export type SourceOfFundsPeriodType = 'rolling' | 'calendar';

export type SourceOfFundsCalendarPeriodValueType = '1' | '7' | '30' | '90' | '365';

export type SourceOfFundsCalculationType = 'net' | 'gross';

export type SourceOfFundsActionOptionType = {
    value: SourceOfFundsAutomatedActionType;
    label: string;
    description: string;
};

export const SOURCE_OF_FUNDS_ACTIONS: Array<SourceOfFundsActionOptionType> = [
    {
        value: 'compliance-restriction',
        label: 'Apply Compliance Restriction',
        description: 'Restrict the account for a configured period.',
    },
    {
        value: 'send-email',
        label: 'Send an Email',
        description: 'Send a notification email to the customer.',
    },
    {
        value: 'show-popup',
        label: 'Display a Pop-Up',
        description: 'Show an in-session pop-up to the customer.',
    },
    {
        value: 'none',
        label: 'None',
        description: 'No automated action for this trigger.',
    },
];

export type SourceOfFundsActionSelectionType = {
    complianceRestriction: boolean;
    sendEmail: boolean;
    showPopup: boolean;
};

export const isNoneSelected = (selection: SourceOfFundsActionSelectionType): boolean => {
    return !selection.complianceRestriction && !selection.sendEmail && !selection.showPopup;
};

export type SourceOfFundsPeriodOptionType<T> = FilterOptionType<T>;
